

import Event = createjs.Event;

export class BasicSoundEvent extends Event {
    public static SONG_PLAYED_COMPLETE: string = "songplayedcomplete";
    public static SONG_BUFFERED_COMPLETE: string = "songbufferedcomplete";
    public static SONG_BUFFERED_ENOUGH: string = "songbufferedenough";

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}

